import { useMemo } from "react";
import { Flex, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

export default function UserDetails() {
  const { t } = useTranslation();
  const fullName = window.localStorage.getItem("@user-fullName");
  const username = window.localStorage.getItem("@user-username");
  const email = window.localStorage.getItem("@user-email");

  const renderUserEmail = useMemo(() => {
    if (!email) {
      return "Not Found";
    }

    if (email.length > 20) {
      if (email.includes("@") && email.includes(".")) {
        const emailSplit1 = email.split("@");
        const emailSplit2 = emailSplit1[1].split(".");
        let hostname = emailSplit2[0];

        if (hostname.length > 2) {
          hostname = `${hostname.substring(0, 2)}..`;
          emailSplit2[0] = hostname;
        } else {
          return email;
        }

        const hostAndDomain = emailSplit2.join(".");
        const emailTruncated = emailSplit1[0] + "@" + hostAndDomain;

        return emailTruncated;
      }
      return email;
    }

    return email;
  }, [email]);

  return (
    <div className="bg-white px-4">
      <div className="p-4 bg-white border-2 border-gray-300 hover:border-secondary rounded-xl">
        <div className="flex justify-center items-center">
          {/* <Text c="#373772" fz="lg" fw={700}>
            Your Details
          </Text> */}
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex-1 flex justify-between gap-2">
            <div className="text-gray-600 font-bold min-w-20">
              {t("user.fullName")}
            </div>
            <div className="text-sm line-clamp-1">{fullName}</div>
          </div>
          <div className="flex-1 flex justify-between gap-2">
            <div className="text-gray-600 font-bold min-w-20">
              {t("user.phone")}
            </div>
            <div className="text-sm line-clamp-1">
              {username.startsWith("+") ? username : `+${username}`}
            </div>
          </div>
          <div className="flex-1 flex justify-between gap-2">
            <div className="text-gray-600 font-bold min-w-20">
              {t("user.email")}
            </div>
            <div className="text-sm line-clamp-1">{renderUserEmail}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
